import styled from 'styled-components'
import React from 'react'
import { Flex, Text, Icon } from 'pcln-design-system'

import Tooltip from '../Tooltip'

const StyledMessaging = styled(Flex)`
  display: inline-flex;
  position: relative;
`

const StyledSpan = styled(Text.span)`
  font-size: 11px;
`

export default class DeltaFreeMessaging extends React.Component {
  constructor() {
    super()
    this.state = { showHover: false }
  }

  showDeltaMessaging() {
    this.setState({
      showHover: true,
    })
  }

  hideDeltaMessaging() {
    this.setState({
      showHover: false,
    })
  }

  render() {
    return (
      <StyledMessaging
        data-test='delta-free-messaging'
        data-testid='delta-free-messaging'
        align='center'
        alignItems='center'
        color={'secondary.base'}
        bg={'background.lightest'}
        mt={1}
        onMouseEnter={() => this.showDeltaMessaging()}
        onMouseLeave={() => this.hideDeltaMessaging()}
      >
        <Icon name='chat' size={20} />
        <StyledSpan pl={'4px'}>Text for free on this flight.</StyledSpan>
        <Tooltip
          isHovered={this.state.showHover}
          color={'secondary.base'}
          tipPosition={'left'}
          tooltipContent='When you use iMessage, Facebook Messenger or WhatsApp!'
        />
      </StyledMessaging>
    )
  }
}
